import React, { createContext, useState, useContext, useEffect } from 'react';
// Import fungsi yang dibutuhkan dari apiService
import { loginAdmin, logoutAdmin } from '../services/apiService'; // Sesuaikan path

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!localStorage.getItem('authToken'));
  const [authToken, setAuthToken] = useState(() => localStorage.getItem('authToken'));
  const [adminUser, setAdminUser] = useState(() => {
    const user = localStorage.getItem('adminUser');
    return user ? JSON.parse(user) : null;
  });

  // useEffect untuk sinkronisasi ke localStorage sudah bagus, tidak perlu diubah
  useEffect(() => {
    if (authToken) {
      localStorage.setItem('authToken', authToken);
      setIsLoggedIn(true);
    } else {
      localStorage.removeItem('authToken');
      setIsLoggedIn(false);
    }
  }, [authToken]);

  useEffect(() => {
    if (adminUser) {
      localStorage.setItem('adminUser', JSON.stringify(adminUser));
    } else {
      localStorage.removeItem('adminUser');
    }
  }, [adminUser]);

  const login = async (email, password) => {
    try {
      // Panggil fungsi dari apiService, bukan fetch langsung
      const data = await loginAdmin(email, password);
      
      console.log('Login successful:', data);
      setAuthToken(data.access_token);
      setAdminUser(data.admin);
      setIsLoggedIn(true);
      return { success: true, data };

    } catch (error) {
      console.error('Login failed:', error.message || 'Invalid credentials');
      setAuthToken(null);
      setAdminUser(null);
      setIsLoggedIn(false);
      return { success: false, message: error.message || 'Invalid credentials' };
    }
  };

  const logout = async () => {
    try {
      // Panggil fungsi logout dari apiService
      await logoutAdmin();
      console.log('Logout API call successful.');
    } catch (error) {
      // apiService sudah menangani token expired (401), jadi di sini hanya log tambahan
      console.warn('Logout API call failed, but logging out client-side anyway:', error.message);
    } finally {
      // Selalu bersihkan state & storage di client, tidak peduli API berhasil atau gagal
      setAuthToken(null);
      setAdminUser(null);
      setIsLoggedIn(false);
    }
  };

  // Fungsi getToken bisa disederhanakan karena kita sudah punya state authToken
  const getToken = () => authToken;

  return (
    <AuthContext.Provider value={{ isLoggedIn, adminUser, user: adminUser, login, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};